module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/18ec610c4e29d83d214a7e844b836cd8.jpg";